import React, {Component} from 'react';

export default class ArticlePreview extends Component {

  makeRelativeImageUrl = (props) => {
    let regex = /[^/]+\.*\.html$/gi;
    let rootPath = props.relativeUrl.replace(regex, '');
    let relativeImageUrl = `posts/${rootPath + props.image}`;
    return relativeImageUrl;
  }

  makeRelativeNavUrl = (props) => {
    return '#' + props.relativeUrl;
  }

  render() {
    return (
      <article className="card mb-4">
        <header className="card-header">
          <div className="card-meta">
            <span>
              created <time className="timeago">{this.props.createdTimeHuman}</time> by {this.props.author}
          </span>
          </div>
          <a href={this.makeRelativeNavUrl(this.props)}>
            <h4 className="card-title">
              {this.props.title}
            </h4>
          </a>
        </header>
        <a href={this.makeRelativeNavUrl(this.props)}>
          <img className="card-img" src={this.makeRelativeImageUrl(this.props)} alt="" />
        </a>
        <div className="card-body">
          <p className="card-text">
            {this.props.description}
          </p>
        </div>
      </article>
    );
  }

}

